import { CriticalError } from '../core/error/error';
import { CopyPlaceConfig } from './collage-designer-config';

export class CopyRuleEncodingError extends CriticalError
{
  public constructor(encoded: string)
  {
    super('malformated "copy-from" attribute.', [encoded]);
  }
}

export namespace CopyRules
{
  export function makePlace(part: string, item?: string): CopyPlaceConfig
  {
    return {
      shortForm: toShortForm(part, item),
      part: part,
      item: item
    };
  }

  export function decodePlace(shortForm: string, currentPart: string):
      CopyPlaceConfig
  {
    if (shortForm.startsWith('//')) {
      return {
        shortForm: shortForm,
        part: shortForm.substr(2),
        item: undefined
      };
    } else {
      const fragments = shortForm.split('/');

      if (fragments.length === 1) {
        return {
          shortForm: shortForm,
          part: currentPart,
          item: fragments[0]
        };
      } else if (fragments.length === 2) {
        return {
          shortForm: shortForm,
          part: fragments[0],
          item: fragments[1]
        };
      } else {
        throw new CopyRuleEncodingError(shortForm);
      }
    }
  }

  function toShortForm(part: string, item?: string): string
  {
    return item ? `${part}/${item}` : `//${part}`;
  }
}
